import { styled, Flex } from '@withjoy/joykit';

export const ToggleWrapper = styled(Flex)`
  border-radius: 4px;
  gap: ${({ theme }) => theme.space[5]};
  border: 1px solid ${({ theme }) => theme.colors.mono3};
  background: ${({ theme }) => theme.colors.white};
`;
